<template>
  <img src="@/assets/images/logos/company-logo-su.png"/>
</template>